import type {AysCodeCodingSystem} from './code-type.model';

export interface AysCodingSystemClassification {
  name: string;
  numberOfDigit: number;
}

export const AYS_CODING_SYSTEM_CLASSIFICATIONS: { [codingSystem in AysCodeCodingSystem]: AysCodingSystemClassification[] } = {
  'ICD-10-UK': [
    {
      name: 'Kategorie (3-Steller)',
      numberOfDigit: 3
    },
    {
      name: 'Subkategorie (4-Steller)',
      numberOfDigit: 4
    },
    {
      name: 'Subkategorie (5-Steller)',
      numberOfDigit: 5
    }
  ],
  'ICD-10-AT': [
    {
      name: 'Kategorie (3-Steller)',
      numberOfDigit: 3
    },
    {
      name: 'Subkategorie (4-Steller)',
      numberOfDigit: 4
    },
    {
      name: 'Subkategorie (5-Steller)',
      numberOfDigit: 5
    }
  ],
  'ICD-10-GM': [
    {
      name: 'Kategorie (3-Steller)',
      numberOfDigit: 3
    },
    {
      name: 'Subkategorie (4-Steller)',
      numberOfDigit: 4
    },
    {
      name: 'Subkategorie (5-Steller)',
      numberOfDigit: 5
    }
  ],
  'OPS': [
    {
      name: 'Kapitel (1-Steller)',
      numberOfDigit: 1
    },
    {
      name: 'Kategorie (3-Steller)',
      numberOfDigit: 3
    },
    {
      name: 'Subkategorie (4-Steller)',
      numberOfDigit: 4
    },
    {
      name: 'Subkategorie (5-Steller)',
      numberOfDigit: 5
    },
    {
      name: 'Subkategorie (6-Steller)',
      numberOfDigit: 6
    }
  ],
  'PROCEDURE-AT': [],
  'OPCS-4': [],
  'G-DRG': [],
  'ICD-10-CH': [
    {
      name: 'Kategorie (3-Steller)',
      numberOfDigit: 3
    },
    {
      name: 'Subkategorie (4-Steller)',
      numberOfDigit: 4
    },
    {
      name: 'Subkategorie (5-Steller)',
      numberOfDigit: 5
    }
  ],
  'CHOP': [],
  'SWISS-DRG': []
};
